import {config} from "@onflow/fcl"

const isServerSide = () => typeof window === "undefined"
const LOCAL_STORAGE = {
    can: !isServerSide(),
    get: async key => JSON.parse(localStorage.getItem(key)),
    put: async (key, value) => localStorage.setItem(key, JSON.stringify(value)),
}

config({
    "debug.accounts": true,
    "logger.level": 2,
    "app.detail.title": "Flow Rider",
    "app.detail.icon": "https://avatars.githubusercontent.com/u/36311083?s=200&v=4",
    "flow.network": "testnet",
    "accessNode.api": "https://rest-testnet.onflow.org", // Mainnet: "https://rest-mainnet.onflow.org"
    // Latest dev deploy of Discovery, handles injected wallets
    "discovery.wallet":
        "https://fcl-discovery-3ed5u3ntu-onflow.vercel.app/testnet/authn", // Mainnet: "https://fcl-discovery.onflow.org/authn"
    "discovery.authn.endpoint":
        "https://fcl-discovery-3ed5u3ntu-onflow.vercel.app/api/testnet/authn",
    "fcl.storage": LOCAL_STORAGE,
    "0xFungibleToken": process.env.REACT_APP_FUNGIBLE_TOKEN_ADDRESS,
    "0xFlowRiderGem": process.env.REACT_APP_FLOW_RIDER_GEM_ADDRESS,
    "0xFlowToken": process.env.REACT_APP_FLOW_TOKEN_ADDRESS
})


export const WCService = {
    f_type: "Service",
    f_vsn: "1.0.0",
    type: "authn",
    method: "WC/RPC",
    uid: "dapper-pro://pair", // use mobile universal link for unique id for this service
    endpoint: "flow_authn",
    optIn: false,
    provider: {
        address: "0x01cf0e2f2f715450", // A Flow address associated with this wallet
        name: "Dapper SC",
        icon: "https://avatars.githubusercontent.com/u/36311083?s=200&v=4",
        description: "Dapper SC Wallet",
        website: "dapper-pro://pair",
        color: null,
        supportEmail: null,
    },
}
